// Row shaping shared by every StackedHorizontalBarChart wrapper.
//
// A level query returns one row per (bar, status colour):
//   id, title, [parentId], [type], status_title, color, value, sort
// and the base chart wants one entry per bar with its colour segments.

export const processChartData = (rows) => {
  const groupedData = {};

  rows.forEach((row) => {
    const id = row.id;
    const title = row.title;
    const parentId = row.parentId ? row.parentId : null;
    const type = row.type ? row.type : null;

    if (!groupedData[id]) {
      groupedData[id] = { name: title, id, parentId, type, children: [] };
    }

    const existingColor = groupedData[id].children.find((child) => child.color === row.color);
    if (existingColor) {
      existingColor.value += row.value;
      existingColor.statusCounts = existingColor.statusCounts || {};
      existingColor.statusCounts[row.status_title] = row.value;
    } else {
      groupedData[id].children.push({
        color: row.color,
        value: row.value,
        statusName: row.status_title,
        sort: row.sort,
        statusCounts: { [row.status_title]: row.value },
      });
    }
  });

  return Object.values(groupedData).map((item) => ({
    ...item,
    children: item.children.sort((a, b) => a.sort - b.sort),
  }));
};

export const executeAndProcessQuery = async (conn, query) => {
  const result = await conn.query(query);
  const rows = result.toArray().map((row) => {
    const jsonRow = row.toJSON();
    return {
      ...jsonRow,
      value: Number(jsonRow.value),
      sort: jsonRow.sort === null || jsonRow.sort === undefined ? 0 : Number(jsonRow.sort),
    };
  });
  return processChartData(rows);
};
